export const SubmitButton = ({ isSubmit, label, className }) => {
  return (
    <>
      <button
        type="submit"
        disabled={isSubmit}
        className={`${
          !isSubmit ? "text-black bg-main" : "text-gray-400 bg-slate-200 "
        } ${
          className ??
          " w-full inline-flex items-center my-3 justify-center rounded-md text-sm font-medium  hover:shadow hover:bg-slate-900 hover:text-white h-9 px-4 py-2"
        } `}
      >
        {isSubmit ? (
          <span className="loading loading-spinner loading-xs mx-2"></span>
        ) : null}{" "}
        {!isSubmit ? label : <p className="text-sm">Veuillez patientez...</p>}
      </button>
    </>
  );
};
